import {
  Companion_getInstance1exe5oe9i5w84 as Companion_getInstance,
  CareTime_FullTime_getInstance2puuq5c8w5gwp as CareTime_FullTime_getInstance,
} from './attendance.mjs';
import { LazyThreadSafetyMode_PUBLICATION_getInstance23f213579at67 as LazyThreadSafetyMode_PUBLICATION_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/Lazy.mjs';
import { lazy1261dae0bgscp as lazy } from '../../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import {
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { PluginGeneratedSerialDescriptorqdzeg5asqhfg as PluginGeneratedSerialDescriptor } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginGeneratedSerialDescriptor.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  equals2au1ep9vhcato as equals,
  protoOf180f3jzyo7rfj as protoOf,
  toString1pkumu07cwy4m as toString,
  createThis2j2avj17cvnv2 as createThis,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { UnknownFieldExceptiona60e3a6v1xqo as UnknownFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializationExceptions.mjs';
import {
  DoubleSerializer_getInstance1tuvibnyg07o1 as DoubleSerializer_getInstance,
  IntSerializer_getInstance3jyhns9ue706g as IntSerializer_getInstance,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/Primitives.mjs';
import {
  typeParametersSerializers2likxjr48tr7y as typeParametersSerializers,
  GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { getNumberHashCode2l4nbdcihl25f as getNumberHashCode } from '../../../../kotlin-kotlin-stdlib/kotlin/js/bitUtils.mjs';
import { throwMissingFieldException2cmke0v3ynf14 as throwMissingFieldException } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginExceptions.mjs';
import { SerializableWithd2dap36updxd as SerializableWith } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/SerializersJs.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
function CareDayInfoWithEmployerSubsidy$Companion$$childSerializers$_anonymous__gw42x3() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        Companion_instance = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, CareDayInfoWithEmployerSubsidy$Companion$$childSerializers$_anonymous__gw42x3), null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance();
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance_0() {
  if (Companion_instance === VOID)
    new (Companion())();
  return Companion_instance;
}
var $serializerClass;
function $serializer() {
  if ($serializerClass === VOID) {
    class $ {
      constructor() {
        $serializer_instance = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareDayInfoWithEmployerSubsidy', this, 5);
        tmp0_serialDesc.addElement_5pzumi_k$('owed', true);
        tmp0_serialDesc.addElement_5pzumi_k$('time', true);
        tmp0_serialDesc.addElement_5pzumi_k$('ageMonths', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transport', true);
        tmp0_serialDesc.addElement_5pzumi_k$('paidByEmployer', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_ui54y1_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value.owed_1, 100.0)) {
          tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 0, value.owed_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.time_1.equals(CareTime_FullTime_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.time_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.ageMonths_1 === 36)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.ageMonths_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.transport_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 3, value.transport_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !equals(value.paidByEmployer_1, 30.0)) {
          tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 4, value.paidByEmployer_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_ui54y1_k$(encoder, value instanceof CareDayInfoWithEmployerSubsidy() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = 0;
        var tmp8_local4 = 0.0;
        var tmp9_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp10_cached = Companion_getInstance_0().$childSerializers_1;
        if (tmp9_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp9_input.decodeDoubleElement_isei84_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp9_input.decodeDoubleElement_isei84_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp9_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp9_input.decodeDoubleElement_isei84_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp9_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp10_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp9_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp9_input.decodeDoubleElement_isei84_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp9_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareDayInfoWithEmployerSubsidy().new_org_thecommunitygroupinc_cares_CareDayInfoWithEmployerSubsidy_j9n8ij_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_0().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), IntSerializer_getInstance(), IntSerializer_getInstance(), DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass = $;
  }
  return $serializerClass;
}
var $serializer_instance;
function $serializer_getInstance() {
  if ($serializer_instance === VOID)
    new ($serializer())();
  return $serializer_instance;
}
var CareDayInfoWithEmployerSubsidyClass;
function CareDayInfoWithEmployerSubsidy() {
  if (CareDayInfoWithEmployerSubsidyClass === VOID) {
    class $ {
      constructor(owed, time, ageMonths, transport, paidByEmployer) {
        Companion_getInstance_0();
        owed = owed === VOID ? 100.0 : owed;
        time = time === VOID ? CareTime_FullTime_getInstance() : time;
        ageMonths = ageMonths === VOID ? 36 : ageMonths;
        transport = transport === VOID ? 0 : transport;
        paidByEmployer = paidByEmployer === VOID ? 30.0 : paidByEmployer;
        this.owed_1 = owed;
        this.time_1 = time;
        this.ageMonths_1 = ageMonths;
        this.transport_1 = transport;
        this.paidByEmployer_1 = paidByEmployer;
      }
      toString() {
        return 'CareDayInfoWithEmployerSubsidy(owed=' + this.owed_1 + ', time=' + toString(this.time_1) + ', ageMonths=' + this.ageMonths_1 + ', transport=' + this.transport_1 + ', paidByEmployer=' + this.paidByEmployer_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.owed_1);
        result = imul(result, 31) + this.time_1.hashCode() | 0;
        result = imul(result, 31) + this.ageMonths_1 | 0;
        result = imul(result, 31) + this.transport_1 | 0;
        result = imul(result, 31) + getNumberHashCode(this.paidByEmployer_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareDayInfoWithEmployerSubsidy()))
          return false;
        if (!equals(this.owed_1, other.owed_1))
          return false;
        if (!this.time_1.equals(other.time_1))
          return false;
        if (!(this.ageMonths_1 === other.ageMonths_1))
          return false;
        if (!(this.transport_1 === other.transport_1))
          return false;
        if (!equals(this.paidByEmployer_1, other.paidByEmployer_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareDayInfoWithEmployerSubsidy_j9n8ij_k$(seen0, owed, time, ageMonths, transport, paidByEmployer, serializationConstructorMarker) {
        Companion_getInstance_0();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.owed_1 = 100.0;
        else
          $this.owed_1 = owed;
        if (0 === (seen0 & 2))
          $this.time_1 = CareTime_FullTime_getInstance();
        else
          $this.time_1 = time;
        if (0 === (seen0 & 4))
          $this.ageMonths_1 = 36;
        else
          $this.ageMonths_1 = ageMonths;
        if (0 === (seen0 & 8))
          $this.transport_1 = 0;
        else
          $this.transport_1 = transport;
        if (0 === (seen0 & 16))
          $this.paidByEmployer_1 = 30.0;
        else
          $this.paidByEmployer_1 = paidByEmployer;
        return $this;
      }
    }
    initMetadataForClass($, 'CareDayInfoWithEmployerSubsidy', CareDayInfoWithEmployerSubsidy, VOID, VOID, VOID, VOID, {0: $serializer_getInstance});
    CareDayInfoWithEmployerSubsidyClass = $;
  }
  return CareDayInfoWithEmployerSubsidyClass;
}
function CareDayInfo$Companion$$childSerializers$_anonymous__5i2kdr() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass_0;
function Companion_0() {
  if (CompanionClass_0 === VOID) {
    class $ {
      constructor() {
        Companion_instance_0 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, CareDayInfo$Companion$$childSerializers$_anonymous__5i2kdr), null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_0();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_0 = $;
  }
  return CompanionClass_0;
}
var Companion_instance_0;
function Companion_getInstance_1() {
  if (Companion_instance_0 === VOID)
    new (Companion_0())();
  return Companion_instance_0;
}
var $serializerClass_0;
function $serializer_0() {
  if ($serializerClass_0 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_0 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareDayInfo', this, 4);
        tmp0_serialDesc.addElement_5pzumi_k$('owed', true);
        tmp0_serialDesc.addElement_5pzumi_k$('time', true);
        tmp0_serialDesc.addElement_5pzumi_k$('ageMonths', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transport', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_atd25d_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value.owed_1, 100.0)) {
          tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 0, value.owed_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.time_1.equals(CareTime_FullTime_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.time_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.ageMonths_1 === 36)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.ageMonths_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.transport_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 3, value.transport_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_atd25d_k$(encoder, value instanceof CareDayInfo() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = 0;
        var tmp8_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp9_cached = Companion_getInstance_1().$childSerializers_1;
        if (tmp8_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp8_input.decodeDoubleElement_isei84_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp9_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp8_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp8_input.decodeDoubleElement_isei84_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp8_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp9_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp8_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp8_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareDayInfo().new_org_thecommunitygroupinc_cares_CareDayInfo_hkpli9_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_1().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), IntSerializer_getInstance(), IntSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_0 = $;
  }
  return $serializerClass_0;
}
var $serializer_instance_0;
function $serializer_getInstance_0() {
  if ($serializer_instance_0 === VOID)
    new ($serializer_0())();
  return $serializer_instance_0;
}
var CareDayInfoClass;
function CareDayInfo() {
  if (CareDayInfoClass === VOID) {
    class $ {
      constructor(owed, time, ageMonths, transport) {
        Companion_getInstance_1();
        owed = owed === VOID ? 100.0 : owed;
        time = time === VOID ? CareTime_FullTime_getInstance() : time;
        ageMonths = ageMonths === VOID ? 36 : ageMonths;
        transport = transport === VOID ? 0 : transport;
        this.owed_1 = owed;
        this.time_1 = time;
        this.ageMonths_1 = ageMonths;
        this.transport_1 = transport;
      }
      toString() {
        return 'CareDayInfo(owed=' + this.owed_1 + ', time=' + toString(this.time_1) + ', ageMonths=' + this.ageMonths_1 + ', transport=' + this.transport_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.owed_1);
        result = imul(result, 31) + this.time_1.hashCode() | 0;
        result = imul(result, 31) + this.ageMonths_1 | 0;
        result = imul(result, 31) + this.transport_1 | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareDayInfo()))
          return false;
        if (!equals(this.owed_1, other.owed_1))
          return false;
        if (!this.time_1.equals(other.time_1))
          return false;
        if (!(this.ageMonths_1 === other.ageMonths_1))
          return false;
        if (!(this.transport_1 === other.transport_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareDayInfo_hkpli9_k$(seen0, owed, time, ageMonths, transport, serializationConstructorMarker) {
        Companion_getInstance_1();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_0().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.owed_1 = 100.0;
        else
          $this.owed_1 = owed;
        if (0 === (seen0 & 2))
          $this.time_1 = CareTime_FullTime_getInstance();
        else
          $this.time_1 = time;
        if (0 === (seen0 & 4))
          $this.ageMonths_1 = 36;
        else
          $this.ageMonths_1 = ageMonths;
        if (0 === (seen0 & 8))
          $this.transport_1 = 0;
        else
          $this.transport_1 = transport;
        return $this;
      }
    }
    initMetadataForClass($, 'CareDayInfo', CareDayInfo, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_0});
    CareDayInfoClass = $;
  }
  return CareDayInfoClass;
}
function CareDayInfoWithSubsidies$Companion$$childSerializers$_anonymous__1kkl0g() {
  return Companion_getInstance().serializer_9w0wvi_k$();
}
var CompanionClass_1;
function Companion_1() {
  if (CompanionClass_1 === VOID) {
    class $ {
      constructor() {
        Companion_instance_1 = this;
        var tmp = this;
        var tmp_0 = LazyThreadSafetyMode_PUBLICATION_getInstance();
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.$childSerializers_1 = [null, lazy(tmp_0, CareDayInfoWithSubsidies$Companion$$childSerializers$_anonymous__1kkl0g), null, null, null, null];
      }
      serializer_9w0wvi_k$() {
        return $serializer_getInstance_1();
      }
    }
    initMetadataForCompanion($);
    CompanionClass_1 = $;
  }
  return CompanionClass_1;
}
var Companion_instance_1;
function Companion_getInstance_2() {
  if (Companion_instance_1 === VOID)
    new (Companion_1())();
  return Companion_instance_1;
}
var $serializerClass_1;
function $serializer_1() {
  if ($serializerClass_1 === VOID) {
    class $ {
      constructor() {
        $serializer_instance_1 = this;
        var tmp0_serialDesc = new (PluginGeneratedSerialDescriptor())('org.thecommunitygroupinc.cares.CareDayInfoWithSubsidies', this, 6);
        tmp0_serialDesc.addElement_5pzumi_k$('owed', true);
        tmp0_serialDesc.addElement_5pzumi_k$('time', true);
        tmp0_serialDesc.addElement_5pzumi_k$('ageMonths', true);
        tmp0_serialDesc.addElement_5pzumi_k$('transport', true);
        tmp0_serialDesc.addElement_5pzumi_k$('paidByEmployer', true);
        tmp0_serialDesc.addElement_5pzumi_k$('paidByGrant', true);
        this.descriptor_1 = tmp0_serialDesc;
      }
      serialize_uxwxsy_k$(encoder, value) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_output = encoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp2_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 0) ? true : !equals(value.owed_1, 100.0)) {
          tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 0, value.owed_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 1) ? true : !value.time_1.equals(CareTime_FullTime_getInstance())) {
          tmp1_output.encodeSerializableElement_isqxcl_k$(tmp0_desc, 1, tmp2_cached[1].get_value_j01efc_k$(), value.time_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 2) ? true : !(value.ageMonths_1 === 36)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 2, value.ageMonths_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 3) ? true : !(value.transport_1 === 0)) {
          tmp1_output.encodeIntElement_krhhce_k$(tmp0_desc, 3, value.transport_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 4) ? true : !equals(value.paidByEmployer_1, 30.0)) {
          tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 4, value.paidByEmployer_1);
        }
        if (tmp1_output.shouldEncodeElementDefault_x8eyid_k$(tmp0_desc, 5) ? true : !equals(value.paidByGrant_1, 30.0)) {
          tmp1_output.encodeDoubleElement_a6rqhe_k$(tmp0_desc, 5, value.paidByGrant_1);
        }
        tmp1_output.endStructure_1xqz0n_k$(tmp0_desc);
      }
      serialize_5ase3y_k$(encoder, value) {
        return this.serialize_uxwxsy_k$(encoder, value instanceof CareDayInfoWithSubsidies() ? value : THROW_CCE());
      }
      deserialize_sy6x50_k$(decoder) {
        var tmp0_desc = this.descriptor_1;
        var tmp1_flag = true;
        var tmp2_index = 0;
        var tmp3_bitMask0 = 0;
        var tmp4_local0 = 0.0;
        var tmp5_local1 = null;
        var tmp6_local2 = 0;
        var tmp7_local3 = 0;
        var tmp8_local4 = 0.0;
        var tmp9_local5 = 0.0;
        var tmp10_input = decoder.beginStructure_yljocp_k$(tmp0_desc);
        var tmp11_cached = Companion_getInstance_2().$childSerializers_1;
        if (tmp10_input.decodeSequentially_xlblqy_k$()) {
          tmp4_local0 = tmp10_input.decodeDoubleElement_isei84_k$(tmp0_desc, 0);
          tmp3_bitMask0 = tmp3_bitMask0 | 1;
          tmp5_local1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp11_cached[1].get_value_j01efc_k$(), tmp5_local1);
          tmp3_bitMask0 = tmp3_bitMask0 | 2;
          tmp6_local2 = tmp10_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
          tmp3_bitMask0 = tmp3_bitMask0 | 4;
          tmp7_local3 = tmp10_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
          tmp3_bitMask0 = tmp3_bitMask0 | 8;
          tmp8_local4 = tmp10_input.decodeDoubleElement_isei84_k$(tmp0_desc, 4);
          tmp3_bitMask0 = tmp3_bitMask0 | 16;
          tmp9_local5 = tmp10_input.decodeDoubleElement_isei84_k$(tmp0_desc, 5);
          tmp3_bitMask0 = tmp3_bitMask0 | 32;
        } else
          while (tmp1_flag) {
            tmp2_index = tmp10_input.decodeElementIndex_bstkhp_k$(tmp0_desc);
            switch (tmp2_index) {
              case -1:
                tmp1_flag = false;
                break;
              case 0:
                tmp4_local0 = tmp10_input.decodeDoubleElement_isei84_k$(tmp0_desc, 0);
                tmp3_bitMask0 = tmp3_bitMask0 | 1;
                break;
              case 1:
                tmp5_local1 = tmp10_input.decodeSerializableElement_uahnnv_k$(tmp0_desc, 1, tmp11_cached[1].get_value_j01efc_k$(), tmp5_local1);
                tmp3_bitMask0 = tmp3_bitMask0 | 2;
                break;
              case 2:
                tmp6_local2 = tmp10_input.decodeIntElement_941u6a_k$(tmp0_desc, 2);
                tmp3_bitMask0 = tmp3_bitMask0 | 4;
                break;
              case 3:
                tmp7_local3 = tmp10_input.decodeIntElement_941u6a_k$(tmp0_desc, 3);
                tmp3_bitMask0 = tmp3_bitMask0 | 8;
                break;
              case 4:
                tmp8_local4 = tmp10_input.decodeDoubleElement_isei84_k$(tmp0_desc, 4);
                tmp3_bitMask0 = tmp3_bitMask0 | 16;
                break;
              case 5:
                tmp9_local5 = tmp10_input.decodeDoubleElement_isei84_k$(tmp0_desc, 5);
                tmp3_bitMask0 = tmp3_bitMask0 | 32;
                break;
              default:
                throw UnknownFieldException().new_kotlinx_serialization_UnknownFieldException_ecrf7z_k$(tmp2_index);
            }
          }
        tmp10_input.endStructure_1xqz0n_k$(tmp0_desc);
        return CareDayInfoWithSubsidies().new_org_thecommunitygroupinc_cares_CareDayInfoWithSubsidies_8yo0ey_k$(tmp3_bitMask0, tmp4_local0, tmp5_local1, tmp6_local2, tmp7_local3, tmp8_local4, tmp9_local5, null);
      }
      get_descriptor_wjt6a0_k$() {
        return this.descriptor_1;
      }
      childSerializers_5ghqw5_k$() {
        var tmp0_cached = Companion_getInstance_2().$childSerializers_1;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        return [DoubleSerializer_getInstance(), tmp0_cached[1].get_value_j01efc_k$(), IntSerializer_getInstance(), IntSerializer_getInstance(), DoubleSerializer_getInstance(), DoubleSerializer_getInstance()];
      }
    }
    protoOf($).typeParametersSerializers_fr94fx_k$ = typeParametersSerializers;
    initMetadataForObject($, '$serializer', VOID, VOID, [GeneratedSerializer()]);
    $serializerClass_1 = $;
  }
  return $serializerClass_1;
}
var $serializer_instance_1;
function $serializer_getInstance_1() {
  if ($serializer_instance_1 === VOID)
    new ($serializer_1())();
  return $serializer_instance_1;
}
var CareDayInfoWithSubsidiesClass;
function CareDayInfoWithSubsidies() {
  if (CareDayInfoWithSubsidiesClass === VOID) {
    class $ {
      constructor(owed, time, ageMonths, transport, paidByEmployer, paidByGrant) {
        Companion_getInstance_2();
        owed = owed === VOID ? 100.0 : owed;
        time = time === VOID ? CareTime_FullTime_getInstance() : time;
        ageMonths = ageMonths === VOID ? 36 : ageMonths;
        transport = transport === VOID ? 0 : transport;
        paidByEmployer = paidByEmployer === VOID ? 30.0 : paidByEmployer;
        paidByGrant = paidByGrant === VOID ? 30.0 : paidByGrant;
        this.owed_1 = owed;
        this.time_1 = time;
        this.ageMonths_1 = ageMonths;
        this.transport_1 = transport;
        this.paidByEmployer_1 = paidByEmployer;
        this.paidByGrant_1 = paidByGrant;
      }
      toString() {
        return 'CareDayInfoWithSubsidies(owed=' + this.owed_1 + ', time=' + toString(this.time_1) + ', ageMonths=' + this.ageMonths_1 + ', transport=' + this.transport_1 + ', paidByEmployer=' + this.paidByEmployer_1 + ', paidByGrant=' + this.paidByGrant_1 + ')';
      }
      hashCode() {
        var result = getNumberHashCode(this.owed_1);
        result = imul(result, 31) + this.time_1.hashCode() | 0;
        result = imul(result, 31) + this.ageMonths_1 | 0;
        result = imul(result, 31) + this.transport_1 | 0;
        result = imul(result, 31) + getNumberHashCode(this.paidByEmployer_1) | 0;
        result = imul(result, 31) + getNumberHashCode(this.paidByGrant_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CareDayInfoWithSubsidies()))
          return false;
        if (!equals(this.owed_1, other.owed_1))
          return false;
        if (!this.time_1.equals(other.time_1))
          return false;
        if (!(this.ageMonths_1 === other.ageMonths_1))
          return false;
        if (!(this.transport_1 === other.transport_1))
          return false;
        if (!equals(this.paidByEmployer_1, other.paidByEmployer_1))
          return false;
        if (!equals(this.paidByGrant_1, other.paidByGrant_1))
          return false;
        return true;
      }
      static new_org_thecommunitygroupinc_cares_CareDayInfoWithSubsidies_8yo0ey_k$(seen0, owed, time, ageMonths, transport, paidByEmployer, paidByGrant, serializationConstructorMarker) {
        Companion_getInstance_2();
        if (!(0 === (0 & seen0))) {
          throwMissingFieldException(seen0, 0, $serializer_getInstance_1().descriptor_1);
        }
        var $this = createThis(this);
        if (0 === (seen0 & 1))
          $this.owed_1 = 100.0;
        else
          $this.owed_1 = owed;
        if (0 === (seen0 & 2))
          $this.time_1 = CareTime_FullTime_getInstance();
        else
          $this.time_1 = time;
        if (0 === (seen0 & 4))
          $this.ageMonths_1 = 36;
        else
          $this.ageMonths_1 = ageMonths;
        if (0 === (seen0 & 8))
          $this.transport_1 = 0;
        else
          $this.transport_1 = transport;
        if (0 === (seen0 & 16))
          $this.paidByEmployer_1 = 30.0;
        else
          $this.paidByEmployer_1 = paidByEmployer;
        if (0 === (seen0 & 32))
          $this.paidByGrant_1 = 30.0;
        else
          $this.paidByGrant_1 = paidByGrant;
        return $this;
      }
    }
    initMetadataForClass($, 'CareDayInfoWithSubsidies', CareDayInfoWithSubsidies, VOID, VOID, VOID, VOID, {0: $serializer_getInstance_1});
    CareDayInfoWithSubsidiesClass = $;
  }
  return CareDayInfoWithSubsidiesClass;
}
//region block: exports
export {
  $serializer_getInstance_0 as $serializer_getInstance2mjsn9cwe2nf,
  Companion_getInstance_1 as Companion_getInstance1mublje3xr06o,
  $serializer_getInstance as $serializer_getInstance2d6r634jjn3di,
  Companion_getInstance_0 as Companion_getInstance3jy8p8cx6vq5r,
  $serializer_getInstance_1 as $serializer_getInstance26w9jyto543s8,
  Companion_getInstance_2 as Companion_getInstance2w6kuu6hdtz7s,
  CareDayInfoWithEmployerSubsidy as CareDayInfoWithEmployerSubsidybae42h7dxu4n,
  CareDayInfoWithSubsidies as CareDayInfoWithSubsidies1r6eshq91lm1r,
  CareDayInfo as CareDayInfoge91quhezyzw,
};
//endregion

//# sourceMappingURL=excelInputs.mjs.map
